import { BrowserRouter as Router } from "react-router-dom";
import { AuthProvider } from "./AuthContext";
import { LanguageProvider } from "./i18n/LanguageContext";
import AppRoutes from "./AppRoutes";
import ErrorBoundary from "./components/ErrorBoundary";

function App() {
  return (
    <AuthProvider>
      <LanguageProvider>
        <ErrorBoundary>
          <Router>
            <AppRoutes />
          </Router>
        </ErrorBoundary>
      </LanguageProvider>
    </AuthProvider>
  );
}

export default App;

